<template>
  <div class="s-bg text-center">
    <center-header :title="$t('member.js')" active="shop" :right="false" :centername="true"></center-header>
    <div class="s-title main-font20 ">{{$t('member.yfje')}}：<span class="font-bold">{{$route.query.price | numFilter}}</span>{{$t('member.y')}}</div>
    <div style="color: #999;">{{$t('member.skf')}}：{{$t('title.c_name')}}</div>
    <div class="paytype">
      <a-radio-group v-model="value" @change="onChange">
        <a-radio :value="1">
          <img src="../assets/img/pay1.png" alt="">
        </a-radio>
        <a-radio :value="2">
          <img src="../assets/img/pay2.png" alt="">
        </a-radio>
        <a-radio :value="3">
          <img src="../assets/img/pay3.png" alt="">
        </a-radio>
      </a-radio-group>
    </div>
    <div class="s-btn">
      <a-button type="primary" block @click="nextStep"> {{$t('member.xyb')}} </a-button>
    </div>
    <div v-html="alipay" v-if="type==2"></div>
    <a-modal v-model="wxshow" :centered="true" width="400px">
      <template slot="footer">
        <a-button type="primary" @click="handleOk">
          {{$t('member.yzf')}}
        </a-button>
      </template>
      <div class="code">
        <div class="qrcode" ref="qrCodeUrl" id="qrcode"></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import CenterHeader from './common/CenterHeader'
  import QRCode from 'qrcodejs2'
  export default {
    components: {
      CenterHeader
    },
    data() {
      return {
        showDg: false,
        value: 1,
        type: 1,
        alipay: '',
        wxpay: '',
        wxshow: false
      }
    },
    filters:{
      numFilter: function(value) {
        let realVal = ''
        if (!isNaN(value) && value !== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = value
        }
        return realVal
      }
    },
    watch: {
      '$route': {
        handler(route) {
          const that = this
          if (route.name === '/settlement') {
            this.type = 1
          }
        }
      }
    },
    methods: {
      handleOk(){
        this.$router.push({
          path: '/shoppingcar'
        })
      },
      onChange(e) {
        this.type = e.target.value
      },
      nextStep() {
        if (this.type == 1) {
          this.$api.dongjuapi.pay_wechat(this.$route.query.no).then(res => {
            this.wxshow = true
            setTimeout(() => {
              document.getElementById('qrcode').innerHTML = ''
              var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: res.data.data.url,
                width: 300,
                height: 300,
                colorDark: '#000000',
                colorLight: '#ffffff'
              })
            }, 100)
          })
        } else if (this.type == 2) {
          this.$api.dongjuapi.pay_alipay(this.$route.query.no).then(res => {
            console.log(res)
            this.alipay = res.data
            this.$nextTick(() => {
              document.forms[0].submit()
            })
          })
        } else if (this.type == 3) {
          this.$router.push({
            path: '/offline?no=' + this.$route.query.no + '&type=' + this.type
          })
        }
        console.log(this.type)
      }
    }
  }
</script>

<style lang="less">
  .s-bg {
    background: #fff;
    padding-bottom: 80px;
  }

  .s-title {
    padding: 117px 0 20px 0;

    span {
      color: #1F5EA5;
      font-size: 30px;
    }
  }

  .paytype {
    margin: 120px 0 100px 0;

    img {
      width: 240px;
      height: 100px;
    }

    .ant-radio-wrapper {
      margin-right: 50px;
    }

    span.ant-radio+* {
      padding: 0 12px;
    }

    .ant-radio-inner {
      width: 30px;
      height: 30px;
    }

    .ant-radio-inner::after {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      top: 4px;
      left: 4px;
    }
  }

  .s-btn {
    width: 200px;
    margin: 0 auto;
    padding-bottom: 50px;

    .ant-btn {
      height: 50px;
    }
  }
  .code{
    width: 300px;
    height: 340px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .qrcode{
      width: 300px;
      height: 300px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-modal-footer{
    border: none;
  }
  .ant-modal-body{
    padding-bottom: 0;
  }
</style>
